module.exports = __webpack_public_path__ + "img/pethouse56.26e2b875.jpg";